// extracted by mini-css-extract-plugin
export default {"column":"FaxResendPopup_column_NslZP"};